import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["__typename", "country", "region", "address2"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { makeReference } from '@apollo/client';
import { AppAlertsContext } from '@infl-ts/ui-app-alerts';
import { useFocusErrors } from '@infl-ts/util-react-hook-form';
import { useMutationMapper } from '@infl-ts/util-use-mutation-mapper';
import { useUnsavedChangesWarning } from '@infl-ts/util-use-unsaved-changes';
import { Box } from '@mui/material';
import * as E from 'fp-ts/Either';
import { constVoid, flow, pipe } from 'fp-ts/function';
import { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { AsyncButton, SaveStates } from '../../async-button';
import { submitFailure, submitSuccess } from './alerts';
import { useEditShippingAddressMutation } from './mutations';
import ShippingAddressInputs, { formatShippingAddressResponse } from './shipping-address-inputs';
import { ShippingInfoBox } from './shipping-info-box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PureShippingInfo = function PureShippingInfo(_ref) {
  var shippingAddressForm = _ref.shippingAddressForm,
      handleSaveChanges = _ref.handleSaveChanges,
      mutationStatus = _ref.mutationStatus,
      isDirty = _ref.isDirty;
  var Saving = SaveStates.Saving,
      Default = SaveStates.Default,
      Success = SaveStates.Success,
      Error = SaveStates.Error;
  var mutationValue = useMutationMapper(mutationStatus, function (_ref2) {
    var editShippingAddress = _ref2.editShippingAddress;
    return editShippingAddress.__typename === 'EditShippingAddressErrors' ? E.left(editShippingAddress) : E.right(editShippingAddress);
  }, [Saving, isDirty ? Default : Success, Error, Default]);

  var _useFocusErrors = useFocusErrors(),
      questionRef = _useFocusErrors.questionRef,
      focusOnFirstError = _useFocusErrors.focusOnFirstError;

  return /*#__PURE__*/_jsxs(ShippingInfoBox, {
    questionRef: questionRef,
    "data-element": "ShippingInfoBox",
    "data-component": "PureShippingInfo",
    "data-source-file": "shipping-info.tsx",
    children: [/*#__PURE__*/_jsx(ShippingAddressInputs, {
      shippingAddressForm: shippingAddressForm,
      "data-element": "ShippingAddressInputs",
      "data-component": "PureShippingInfo",
      "data-source-file": "shipping-info.tsx"
    }), /*#__PURE__*/_jsx(Box, {
      sx: {
        width: 1,
        display: 'flex',
        justifyContent: 'flex-end'
      },
      "data-element": "Box",
      "data-source-file": "shipping-info.tsx",
      children: /*#__PURE__*/_jsx(AsyncButton, {
        status: mutationValue,
        onClick: shippingAddressForm.handleSubmit(handleSaveChanges, focusOnFirstError),
        text: ['Saving...', 'Saved', 'Save', 'Save'],
        "data-element": "AsyncButton",
        "data-source-file": "shipping-info.tsx"
      })
    })]
  });
};

var useProps = function useProps(_ref3) {
  var profileId = _ref3.profileId,
      _ref3$shippingAddress = _ref3.shippingAddress,
      __typename = _ref3$shippingAddress.__typename,
      country = _ref3$shippingAddress.country,
      region = _ref3$shippingAddress.region,
      address2 = _ref3$shippingAddress.address2,
      rest = _objectWithoutProperties(_ref3$shippingAddress, _excluded);

  var shippingAddressForm = useForm({
    defaultValues: {
      shippingAddress: _objectSpread(_objectSpread({}, rest), {}, {
        address2: address2 !== null && address2 !== void 0 ? address2 : '',
        country: country !== null && country !== void 0 ? country : null,
        region: region !== null && region !== void 0 ? region : null
      })
    }
  });

  var _useUnsavedChangesWar = useUnsavedChangesWarning(shippingAddressForm.formState.isDirty),
      setDirtyState = _useUnsavedChangesWar.setDirtyState,
      isDirty = _useUnsavedChangesWar.isDirty;

  var _useContext = useContext(AppAlertsContext),
      showAlert = _useContext.showAlert;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useEditShippingAddre = useEditShippingAddressMutation({
    onCompleted: E.match(function () {
      return showAlert(submitFailure(handleSaveChanges, t));
    }, function (_ref4) {
      var editShippingAddress = _ref4.editShippingAddress;

      if (editShippingAddress.__typename === 'EditShippingAddressResult') {
        showAlert(submitSuccess(t));
        setDirtyState(false);
      } else {
        showAlert(submitFailure(handleSaveChanges, t));
      }
    }),
    update: function update(cache, data) {
      return pipe(data, E.match(constVoid, function (_ref5) {
        var editShippingAddress = _ref5.editShippingAddress;

        if (editShippingAddress.__typename === 'EditShippingAddressResult') {
          var _result$address, _result$country, _result$region;

          cache.modify({
            id: cache.identify(makeReference("Profile:".concat(profileId))),
            fields: {
              shippingAddress: function shippingAddress() {
                return editShippingAddress.address;
              }
            }
          });
          var result = editShippingAddress.address;
          shippingAddressForm.reset({
            shippingAddress: _objectSpread(_objectSpread({}, result), {}, {
              address2: (_result$address = result === null || result === void 0 ? void 0 : result.address2) !== null && _result$address !== void 0 ? _result$address : '',
              country: (_result$country = result === null || result === void 0 ? void 0 : result.country) !== null && _result$country !== void 0 ? _result$country : null,
              region: (_result$region = result === null || result === void 0 ? void 0 : result.region) !== null && _result$region !== void 0 ? _result$region : null
            })
          });
        }
      }));
    }
  }),
      _useEditShippingAddre2 = _slicedToArray(_useEditShippingAddre, 2),
      editShippingAddress = _useEditShippingAddre2[0],
      mutationStatus = _useEditShippingAddre2[1];

  var handleSaveChanges = function handleSaveChanges() {
    return editShippingAddress({
      variables: {
        input: formatShippingAddressResponse(shippingAddressForm.getValues('shippingAddress'))
      }
    });
  };

  return {
    shippingAddressForm: shippingAddressForm,
    handleSaveChanges: handleSaveChanges,
    mutationStatus: mutationStatus,
    isDirty: isDirty
  };
};

export default Object.assign(flow(useProps, PureShippingInfo), {
  displayName: 'ShippingInfo'
});